import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const StyledTypography = styled(Typography)`
  color: ${props => !props.selected ? "#000" : "#5062F0"};
`